<ng-container *abcLet="res$ | async as res">
  <div class="containerVehicleDowntime resource_event_border">
    <div class="detailContainerVehicleDowntime">
      <div fxLayout="row" class="icon-container">
        <mat-icon
          class="iconHeaderVehicleDowntime"
          [svgIcon]="res.svgName(this.resourcesNavigationContext.resourceEventGroup.resource.resourceType.iconName)"
        ></mat-icon>
        <span class="resource_event_boldLabel">{{
          this.resourcesNavigationContext.resourceEventGroup.resource.name
        }}</span>
      </div>
      <resource-navigation></resource-navigation>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" class="startContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'date')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartDate')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.date"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'time')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-StartTime')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.time"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" class="endContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'endDate')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndDate')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.endDate"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'endTime')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-EndTime')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.endTime"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" class="endContainer">
        <abc-drop-down-box
          #dropDownDownReason
          (onValueChanged)="safeSetValue($event, 'idRefResourceEventType')"
          [disabled]="this.isDisabled"
          [labelMode]="'floating'"
          [label]="res.get('Resources-ResourceEvent-DownReason')"
          [stylingMode]="'filled'"
          [validationStatus]="'valid'"
          [value]="this.resourceEvent?.idRefResourceEventType"
          [ngStyle]="{ width: '476px' }"
          [ngStyle.xs]="{ width: '380px' }"
        ></abc-drop-down-box>

        <div class="inputAjustment">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'resultValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-HoursCount')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.resultValue"
            [ngStyle]="{ width: '160px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row">
        <div fxLayout.xs="column">
          <abc-text-area
            (onValueChanged)="safeSetValue($event, 'comment')"
            [disabled]="this.isDisabled"
            [height]="'90px'"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Description')"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.comment"
            [ngStyle]="{ width: '652px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-text-area>
        </div>
      </div>
    </div>
  </div>
</ng-container>
